<div class="table-container">
    <div *ngIf="!disabled_pagenat && pagenat && pagenat.pagenat && pagenat.pagenat.length > 0" class="pagenat-bar">
        <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" *ngIf="pagenat.previous"><a class="page-link" (click)="selectPage(pagenat.previous)">Previous</a></li>
              <li class="page-item" *ngFor="let p of pagenat.pagenat"><a class="page-link" (click)="selectPage(p)">{{p}}</a></li>
              <li class="page-item" *ngIf="pagenat.next"><a class="page-link" (click)="selectPage(pagenat.next)">Next</a></li>
            </ul>
        </nav>
        <select class="form-select form-select-sm" style="width: auto;" *ngIf="pagenat.page_no && pagenat.page_no.length > 0" [(ngModel)]="pagenat.per_page" (change)="selectPage(1)">
            <option *ngFor="let p of pagenat.page_no" [value]="p">{{p}}</option>
        </select>
    </div>

<table class="table">
    <thead>
        <tr *ngIf="setting">
            <th *ngFor="let h of setting" class="table-header">
                <ng-container *ngIf="!h.hide">
                    {{h.label}}
                </ng-container>
            </th>
        </tr>
        <tr *ngIf="setting && setting.filter && filterEnabled()">
            <th *ngFor="let h of setting" class="table-header" style="background: #f9fafb;">
                <ng-container *ngIf="h.filter && h.filter == 'string'">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="filter[h.key]" [placeholder]="'Search ' + [h.label]" (change)="search($event)"/>
                </ng-container>
                <ng-container *ngIf="h.filter && h.filter == 'status'">
                    <select class="form-select form-select-sm" [(ngModel)]="filter[h.key]" (change)="search($event)">
                        <option value="1">Active</option>
                        <option value="0">Disabled</option>
                    </select>
                </ng-container>
            </th>
        </tr>
    </thead>
    <tbody *ngIf="content && content.length > 0">
        <tr *ngFor="let c of content; let i = index;" class="{{row_setting && row_setting.class ? row_setting.class(c) : ''}}">
            <td *ngFor="let h of setting">
                <container-element [ngSwitch]="h.type">
                    <ng-container *ngSwitchCase="'index'">
                        {{1+ i + (pagenat.current && pagenat.per_page ? (pagenat.current - 1) * pagenat.per_page : 0) }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'status'">
                        <span *ngIf="h.key === 'status' && c.is_suspended == 1" class="badge bg-danger">Suspended</span>
                        <span *ngIf="h.key !== 'status' || c.is_suspended != 1" class="badge" [ngClass]="c[h.key] ? 'bg-success' : 'bg-secondary'">{{c[h.key] ? 'Active' : 'Disabled'}}</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'voucher'">
                        <span class="badge" [ngClass]="c[h.key] == 2 ? 'bg-primary' : c[h.key] == 1 ? 'bg-success' : 'bg-danger'">
                            {{c[h.key] == 2 ? 'New' : c[h.key] == 1 ? 'Used' : 'Disabled'}}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'notificationstatus'">
                        <span class="badge" [ngClass]="c[h.key] == '1' ? 'bg-success' : 'bg-warning text-dark'">
                            {{c[h.key] == '1' ? 'Link' : c[h.key] == '2' ? 'Unlink' : 'Disabled'}}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'yesno'">
                        <span class="badge" [ngClass]="c[h.key] ? 'bg-success' : 'bg-secondary'">{{c[h.key] ? 'Yes' : 'No'}}</span>
                    </ng-container>


                    <ng-container *ngSwitchCase="'string'">
                        {{c[h.key]}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'html'">
                        <div [innerHTML]="c[h.key]"></div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'claim_voucher'">
                        <a class="btn btn-sm btn-outline-primary" *ngIf="!c[h.key]" (click)="button(h.action, c)">{{h['label']}}</a>
                        <span *ngIf="c[h.key]" style="white-space: nowrap;">{{c[h.key] | date: 'dd-MM-y h:mm a'}}</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                        {{c[h.key] | date: 'dd-MM-y'}}
                    </ng-container>

                    <ng-container *ngSwitchCase="'datetime'">
                        <span *ngIf="c[h.key]" style="white-space: nowrap;">{{c[h.key] | date: 'dd-MM-y h:mm a'}}</span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'last-online'">
                        <span *ngIf="c[h.key]" style="white-space: nowrap;">{{c[h.key] | date: 'dd-MM-y h:mm a'}}</span>
                        <span *ngIf="!c[h.key]" class="text-muted" style="white-space: nowrap;">
                            Never <small *ngIf="h.fallbackKey && c[h.fallbackKey]">(registered {{c[h.fallbackKey] | date: 'dd-MM-y h:mm a'}})</small>
                        </span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'work-status'">
                        <span *ngIf="!h.visible || h.visible(c)" class="badge" [ngClass]="c[h.key] ? 'bg-success' : 'bg-secondary'">
                            {{c[h.key] ? 'Working' : 'Offline'}}
                        </span>
                        <span *ngIf="h.visible && !h.visible(c)" class="text-muted">—</span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'alert-status'">
                        <span *ngIf="!h.visible || h.visible(c)" class="badge" [ngClass]="c[h.key] ? 'bg-danger' : 'bg-success'">
                            {{c[h.key] ? 'Overdue' : 'OK'}}
                        </span>
                        <span *ngIf="h.visible && !h.visible(c)" class="text-muted">—</span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'price'">
                       <div class="d-flex flex-row justify-content-between"><span>RM</span> <span>{{c[h.key] ? c[h.key] : 0 | number : '1.2-2'}}</span></div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'link'">
                       <a class="btn btn-sm btn-outline-primary" [routerLink]="h.blockWhenSuspended && c.is_suspended == 1 ? null : [h.link, c[h.key]]" [class.disabled]="h.blockWhenSuspended && c.is_suspended == 1" [attr.aria-disabled]="h.blockWhenSuspended && c.is_suspended == 1 ? true : null">{{h['label']}}</a>
                    </ng-container>

                    <ng-container *ngSwitchCase="'external-link'">
                        <a class="btn btn-sm btn-outline-primary" [href]="h.link + c[h.key]" target="_blank">{{h['label']}}</a>
                     </ng-container>

                    <ng-container *ngSwitchCase="'link-status'">
                       <a class="btn btn-sm btn-outline-primary" [routerLink]="h.blockWhenSuspended && c.is_suspended == 1 ? null : [h.link, c[h.key]]" [class.disabled]="h.blockWhenSuspended && c.is_suspended == 1" [attr.aria-disabled]="h.blockWhenSuspended && c.is_suspended == 1 ? true : null" *ngIf="c['status'] == 1 && c.is_suspended != 1">{{h['label']}}</a>
                    </ng-container>

                    <ng-container *ngSwitchCase="'delete'">
                       <a class="btn btn-sm btn-outline-danger" (click)="delete(c[h.title], h.table, c[h.key])">{{h['label']}}</a>
                    </ng-container>

                    <ng-container *ngSwitchCase="'button'">
                        <a class="btn btn-sm btn-outline-primary" *ngIf="!h.visible || h.visible(c)" (click)="button(h.action, c)">{{h['label']}}</a>
                     </ng-container>

                     <ng-container *ngSwitchCase="'update-payment'">
                        <span *ngIf="c['is_loading']" class="text-muted" style="font-size: 12px;">Loading...</span>
                        <a class="btn btn-sm btn-outline-primary" (click)="button(h.action, c)" *ngIf="(c['status'] == 'Pending' && c['callback_response']) && (!c['is_loading'])">{{h['label']}}</a>
                     </ng-container>

                    <ng-container *ngSwitchDefault>
                        {{c[h.key]}}
                    </ng-container>
                </container-element>
            </td>
        </tr>
    </tbody>
    <tbody *ngIf="setting && content && content.length == 0 && !is_loading">
        <tr>
            <td [attr.colspan]="setting.length" class="text-center text-muted py-4" style="font-style: italic;">
                No Data Available
            </td>
        </tr>
    </tbody>
    <tbody *ngIf="setting.length > 0 && is_loading">
        <tr>
            <td [attr.colspan]="setting.length" class="text-center text-muted py-4">
                <div class="d-flex align-items-center justify-content-center gap-2">
                    <div class="loader"></div> <span style="font-style: italic;">Loading...</span>
                </div>
            </td>
        </tr>
    </tbody>
    <tbody *ngIf="is_load && (!setting || setting.length == 0)">
        <tr>
            <td class="text-center text-muted py-3" style="font-style: italic;">
                Table is not setup properly.
            </td>
        </tr>
    </tbody>
    <tfoot *ngIf="footerEnabled()">
        <tr>
            <td *ngFor="let h of setting" class="fw-bolder">
                <ng-container *ngIf="h.footer_label">
                    {{h.footer_label}}
                </ng-container>
                <ng-container *ngIf="h.footer_key">
                    <ng-container [ngSwitch]="h.footer_type">
                        <ng-container *ngSwitchCase="'price'">
                            <div class="d-flex flex-row justify-content-between"><span>RM</span> <span>{{summary[h.footer_key] ? summary[h.footer_key] : 0 | number : '1.2-2'}}</span></div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{summary[h.footer_key]}}
                        </ng-container>
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tfoot>
</table>

<div *ngIf="!disabled_pagenat && pagenat && pagenat.pagenat && pagenat.pagenat.length > 0" class="pagenat-bar">
    <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" *ngIf="pagenat.previous"><a class="page-link" (click)="selectPage(pagenat.previous)">Previous</a></li>
          <li class="page-item" *ngFor="let p of pagenat.pagenat"><a class="page-link" (click)="selectPage(p)">{{p}}</a></li>
          <li class="page-item" *ngIf="pagenat.next"><a class="page-link" (click)="selectPage(pagenat.next)">Next</a></li>
        </ul>
    </nav>
    <select class="form-select form-select-sm" style="width: auto;" *ngIf="pagenat.page_no && pagenat.page_no.length > 0" [(ngModel)]="pagenat.per_page" (change)="selectPage(1)">
        <option *ngFor="let p of pagenat.page_no" [value]="p">{{p}}</option>
    </select>
</div>

</div>
